import { REDUX_ACTIONS } from 'utils/constants';

export interface DeviceDataState {
  user_agent?: string;
  device_country_code?: string;
  device_country_name?: string;
  device_city?: string;
  device_postal?: string;
  device_state?: string;
}
export const initialState: DeviceDataState = {
  user_agent: null,
  device_country_code: null,
  device_country_name: null,
  device_city: null,
  device_postal: null,
  device_state: null,
};

export default function deviceDataReducer(state = initialState, action: any): DeviceDataState {
  switch (action.type) {
    case REDUX_ACTIONS.UPDATE_DEVICE_DATA:
      return {
        ...state,
        user_agent: action.user_agent,
        device_country_code: action.device_country_code,
        device_country_name: action.device_country_name,
        device_city: action.device_city,
        device_postal: action.device_postal,
        device_state: action.device_state,
      };
    default:
      return state;
  }
}
